import React from "react";

export const DownIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2.93775 6.05538C2.93775 5.89841 2.99152 5.76106 3.09904 5.64333C3.20657 5.5256 3.34902 5.46674 3.5264 5.46674L12.4739 5.46674C12.6504 5.46674 12.7925 5.5256 12.9 5.64333C13.0076 5.76106 13.0617 5.89841 13.0625 6.05538C13.0625 6.09463 13.0036 6.23198 12.8859 6.46744L8.61821 10.7351C8.5201 10.8332 8.42199 10.9019 8.32388 10.9412C8.22577 10.9804 8.11786 11 8.00013 11C7.8824 11 7.77448 10.9804 7.67637 10.9412C7.57826 10.9019 7.48015 10.8332 7.38205 10.7351L3.11435 6.46744C3.05548 6.40857 3.01114 6.345 2.98131 6.27672C2.95149 6.20843 2.93697 6.13465 2.93775 6.05538Z"
        fill="#3B82F6"
      />
    </svg>
  );
};
